<template>
    <div :class="[
        'input-email',
        { 'is-error': isError }
    ]">
        <input 
            v-model="inputValue" 
            :placeholder="placeholder"
            @input="onInput"
        />
    </div>
</template>

<script>
import ValidateMixin from '@/mixins/ValidateMixin'

export default {
    mixins: [
        ValidateMixin
    ],

    props: {
        value: {
            type: String,
            required: false,
            default: ''
        },
        placeholder: {
            type: String,
            required: false,
            default: 'np. email@google.pl'
        }
    },

    watch: {
        value: {
            handler: function(value) {
                this.inputValue = value
            },
            immediate: true
        }
    },

    data() {
        return {
            inputValue: this.value
        }
    },

    computed: {
        validatedValue() {
            return this.inputValue
        }
    },

    methods: {
        onInput() {
            this.$emit('input', this.inputValue)

            this.isError = false
        },

        getValidationConstraints() {
            return [
                this.validateAgainstRequired(),
                this.validateAgainstEmailRegex()
            ]
        }
    }
}
</script>

<style lang="scss">
.input-email {
    @include input-simple();

    input {
        @include size(100%, 38px);
    }
}
</style>
